import { useTranslation } from "react-i18next";
import {
  ORGANIZATION_ROLE_ORDER,
  OrganizationRoleType,
} from "@/partner/entities/organizationUsers";
import { useLiveEnabled } from "@/partner/entities/instance";

export interface RoleOption {
  value: OrganizationRoleType;
  label: string;
  description: string;
}

/**
 * Опции ролей для чекбоксов в диалогах «Пригласить сотрудника»/«Сотрудник»:
 * порядок и значения — из entity (`ORGANIZATION_ROLE_ORDER`), подписи и
 * описания — из сида (`team.roles.<role>.label|description`).
 *
 * Роль «эфиры» предлагается только там, где эфиры включены
 * (`instance.liveEnabled`): раздавать права на скрытый раздел незачем.
 * Уже выданную роль это не отзывает, чипы в списке сотрудников читают
 * подписи напрямую и продолжают её показывать.
 */
export function useRoleOptions(): RoleOption[] {
  const { t } = useTranslation();
  const liveEnabled = useLiveEnabled();

  return ORGANIZATION_ROLE_ORDER.filter(
    (value) => liveEnabled || value !== OrganizationRoleType.StreamsType
  ).map((value) => ({
    value,
    label: t(`team.roles.${value}.label`),
    description: t(`team.roles.${value}.description`),
  }));
}
